import React from "react";

var Component = function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.017 17.649l5.582-1.276M3.642 15.201l5.697-1.914M10.302 15.773a20.214 20.214 0 0 0-.45-1.044 8.828 8.828 0 0 1-.762-2.835 1.62 1.62 0 0 1-.007-.116c-.042-2.493.484-4.891-.341-7.256C8.219 3.022 6.839 1 4.855 1a3.05 3.05 0 0 0-.691.08C.868 2.207.843 6.369 1.094 8.839c.086.844.673 2.237 1.318 3.605.72 1.527 1.338 3.099 1.94 4.677.422 1.106.993 2.233 1.613 2.553A2.96 2.96 0 0 0 7.326 20c.301 0 .608-.044.914-.133 2.115-.683 2.59-2.374 2.062-4.094zM22.863 18.575c-.293-2.043-.439-4.104-.565-6.165-.063-1.035-.182-1.984-.426-2.558C21.052 7.926 19.429 5 16.761 5c-.303 0-.619.038-.948.118-2.195.783-2.503 3.524-2.228 5.188.391 2.358 1.914 4.042 3.01 6.098.014.026.031.063.05.108.305.71.479 1.468.549 2.237.069.754.169 1.676.203 1.845.288 1.39 1.133 2.406 2.584 2.406.301 0 .627-.044.981-.137a3.165 3.165 0 0 0 1.796-1.34c.335-.53.275-1.763.105-2.948z"
  })));
};

Component.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
Component.displayName = "steps";
export default Component;